import styled from "@emotion/styled";
import colors from "styles/colors";
import { TOP_LAYER } from "constants/z-index";
export const StyledTryItYourselfEditorComponent = styled.div`
  height: calc(100vh - 70px);
  position: relative;

  .authorization-overlay {
    background-color: rgba(256, 256, 256, 0.5);
    z-index: ${TOP_LAYER};
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;

    .authorization-container {
      background-color: white;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: start;
      padding: 44px;
      width: 500px;
      height: 350px;
      border-radius: 12px;
      box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.2);

      .enter-token-message {
        font-size: 0.875rem;
        padding: 12px 0;
      }

      .enter-token-title {
        font-size: 1.375rem;
        font-weight: 700;
        padding: 12px 0;
      }

      .token-input-wrapper {
        position: relative;
        height: 44px;
        width: 100%;
        margin: 12px 0;

        input {
          height: 100%;
          width: 100%;

          padding: 0 16px;
          border-radius: 4px;
          outline: none;
          border: 1px solid ${colors.grey};
          font-size: 0.8125rem;

          ::placeholder {
            color: ${colors.grey};
          }
        }
      }

      .where-is-the-token {
        font-size: 0.8125rem;
        text-decoration: none;
        color: ${colors["brand-blue"]};

        &:hover {
          color: ${colors["light-blue-hover"]};
        }
      }

      .set-token-btn-container {
        margin-top: 32px;
        display: flex;
        align-self: flex-end;
      }
    }
  }
`;
